import React, { Component } from 'react'
import Main from './../../components/main'
import { Table, Input, Select, Pagination, message, Row, Col } from 'antd'
import moment from 'moment'
import PropTypes from 'prop-types'

import Filter from './../../components/filter'
import { bankCodeMapping, destBanks, originBanks, statuses } from './data'
import { numberToMoney, moneyToNumber } from './../../utils/formatter/currency'
import {
  API_GET_ORDERS,
  API_EDIT_ORDER_STATUS,
  API_EDIT_ORDER_STATUS_READYTOREFUND,
} from './../../api'
import OrderDetail from './order-detail'
import ModalReadyToRefund from './modalReadyToRefund'
import './order.css'

class Order extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dataCount: 0,
      data: [],
      originalData: [],
      searchText: '',
      modal: false,
      modalOrderDetail: false,
      modalOrderId: 0,
      modalUser: null,
      currentPage: 1,
      loadingTable: false,
      filterVisible: {
        status: false,
        destBank: false,
        originBank: false,
      },
      statusFilter: [],
      destBankFilter: [],
      refund: {},
      selectedRowKeys: [],
      loadingSelected: false,
    }
  }

  componentDidMount() {
    const { page, status, destBank, originBank } = this.urlQueryPage()
    this.updateData(page, status, destBank, originBank)
    this.intervalHandler = setTimeout(this.componentDidMount.bind(this), 5 * 60 * 1000)
  }

  componentDidUpdate() {
    const { page, status, destBank, originBank } = this.urlQueryPage()
    if (page !== this.state.currentPage) {
      this.updateData(page, status, destBank, originBank)
    }
  }

  componentWillUnmount() {
    clearTimeout(this.intervalHandler)
  }

  onInputChange = (e) => {
    this.setState({ searchText: e.target.value })
  }

  onFilterVisibleChange = (visible, field) =>
    this.setState({
      ...this.state,
      filterVisible: {
        ...this.state.filterVisible,
        [field]: visible,
      },
    })

  onSelectChange = (selectedRowKeys) => {
    this.setState({ ...this.state, selectedRowKeys })
  }

  getOrders = (query, page = 1) => {
    this.setState({ currentPage: page })
    API_GET_ORDERS(query)
      .then(res => this.setState({
        ...this.state,
        dataCount: res.data.count,
        data: res.data.data,
        originalData: res.data.data,
        loadingTable: false,
        currentPage: page,
      }))
      .catch(() => {
        message.error('Fetch Data Failed')
      })
  }

  handleChangeStatus = (e, orderId) => {
    e === 'readytorefund'
      ? this.setState({ ...this.state, modalOrderId: orderId, modal: true })
      : this.changeStatus(e, orderId)
  }

  handleChangeStatusSelected = async (e) => {
    this.setState({ ...this.state, loadingSelected: true })
    await Promise.all(this.state.selectedRowKeys.map((orderId) => {
      if (e !== 'readytorefund') {
        this.changeStatus(e, orderId)
      }
      return orderId
    }))
    this.setState({ ...this.state, loadingSelected: false })
  }

  changeStatus = (newStatus, orderId) => {
    const dataChosen = this.state.data.find(x => x.orderId === orderId)
    if (dataChosen && dataChosen.status === newStatus) return
    API_EDIT_ORDER_STATUS(orderId, { status: newStatus })
      .then(() =>
        this.setState({
          ...this.state,
          modalOrderId: 0,
          data: this.state.data.map((x) => {
            if (x.orderId === orderId) x.status = newStatus
            return x
          }),
        }))
      .catch(() => {
        message.error('Edit Order Status Failed')
      })
  }

  changeRefundBank = (e) => {
    this.setState({
      ...this.state,
      refund: {
        ...this.state.refund,
        bank: e,
      },
    })
  }

  changeRefundInput = (e, field) => {
    let val = ''
    if (field === 'amount') {
      val = e.target.value.replace('Rp. ', '')
      val = Number.isNaN(val) ? val : moneyToNumber(val)
    }
    this.setState({
      ...this.state,
      refund: {
        ...this.state.refund,
        [field]: field === 'amount' ? numberToMoney(val || 0) : e.target.value,
      },
    })
  }

  search = (value) => {
    this.loadingTable()
    this.getOrders(value ? { query: value } : null)
  }

  filter = async ({ field, value = [] } = {}) => {
    await this.setState({
      ...this.state,
      filterVisible: {
        ...this.state.filterVisible,
        [field]: false,
      },
    })
    if (field === 'status') {
      await this.setState({ statusFilter: value })
    }
    if (field === 'destBank') {
      if (value.length > 0) {
        value.forEach((item, idx) => {
          value[idx] = bankCodeMapping[item]
        })
      }
      await this.setState({ destBankFilter: value })
    }
    if (field === 'originBank') {
      if (value.length > 0) {
        value.forEach((item, idx) => {
          value[idx] = bankCodeMapping[item]
        })
      }
      await this.setState({ originBankFilter: value })
    }
    console.log(field, value)
    await this.changePage(1)
    await this.loadingTable()
    await this.getOrders(Object.assign(
      {},
      this.state.statusFilter.length > 0 && { status: this.state.statusFilter },
      this.state.destBankFilter.length > 0 && { destBank: this.state.destBankFilter },
      this.state.originBankFilter.length > 0 && { originBank: this.state.originBankFilter },
    ))
  }

  closeModal = () =>
    this.setState({ ...this.state, modal: false, modalOrderId: 0, refund: {} })
  openModalOrderDetail = (orderId, user) =>
    this.setState({
      ...this.state,
      modalOrderDetail: true,
      modalOrderId: orderId,
      modalUser: user,
    })
  closeModalOrderDetail = () =>
    this.setState({ ...this.state, modalOrderDetail: false, modalOrderId: 0 , modalUser: null})
  loadingTable = () => this.setState({ ...this.state, loadingTable: true })

  modalOk = () => {
    const { modalOrderId, refund } = this.state
    API_EDIT_ORDER_STATUS_READYTOREFUND(modalOrderId, {
      ...refund,
      bank: refund.bank.replace('Bank ', '').toLowerCase(),
    })
      .then((res) => {
        this.setState({
          ...this.state,
          modalOrderId: 0,
          data: this.state.data.map((x) => {
            if (x.orderId === modalOrderId) return res.data
            return x
          }),
        })
        this.closeModal()
      })
      .catch(() => {
        message.error('Edit Order Status Failed')
      })
  }

  changePage = (page) => {
    const status = this.state.statusFilter.length > 0 ? '&status[]='.concat(this.state.statusFilter.join('&status[]=')) : ''
    const destBank = this.state.destBankFilter.length > 0 ? '&destBank[]='.concat(this.state.destBankFilter.join('&destBank[]=')) : ''
    const originBank = this.state.originBankFilter.length > 0 ? '&originBank[]='.concat(this.state.originBankFilter.join('&originBank[]=')) : ''
    this.props.history.push(`/orders?page=${page}`.concat(status).concat(destBank).concat(originBank))
    window.scrollTo(0, 0)
  }

  urlQueryPage = () => {
    let page = this.props.location.search
      .split('&')[0]
      .replace('?', '')
      .split('=')
    page = page.length > 1 ? page[1] : '1'
    page = Number.isNaN(page) ? 1 : parseInt(page, 10)
    const status = this.props.location.search.split('&').filter(e => e.startsWith('status[]=')).map(e => e.substring('status[]='.length, e.length))
    const destBank = this.props.location.search.split('&').filter(e => e.startsWith('destBank[]=')).map(e => e.substring('destBank[]='.length, e.length))
    const originBank = this.props.location.search.split('&').filter(e => e.startsWith('originBank[]=')).map(e => e.substring('originBank[]='.length, e.length))
    return { page, status, destBank, originBank }
  }

  updateData = async (page = 1, status = [], destBank = [], originBank = []) => {
    await this.setState({ ...this.state, currentPage: page, statusFilter: status, destBankFilter: destBank, originBankFilter: originBank })
    this.loadingTable()
    this.getOrders({ page, status, destBank, originBank }, page)
  }

  render() {
    const {
      modal,
      currentPage,
      dataCount,
      modalOrderDetail,
      data,
      loadingTable,
      modalOrderId,
      modalUser,
      filterVisible,
      statusFilter,
      refund,
      selectedRowKeys,
      loadingSelected,
    } = this.state
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    }
    const columns = [
      {
        title: 'Detail',
        dataIndex: 'user.fullName',
        key: 'user.fullName',
        render: (text, record) => (
          <div>
            <b>Order ID</b>
            <div className="block">{record.orderId}</div>
            <strong className="order_name">{text}</strong>
            <div>Phone : {record.notificationPhone}</div>
            <div>User ID : {record.user.userId}</div>
            <button
              className="order_order-detail-btn"
              onClick={() => this.openModalOrderDetail(record.orderId, record.user)}
            >
              Order Detail
            </button>
          </div>
        ),
      },
      {
        title: 'Time',
        dataIndex: 'createdAt',
        key: 'createdAt',
        render: (text, record) => (
          <div>
            <div>Created:</div>
            <div className="block">
              {moment(text).format('DD MMM YYYY, HH:mm')}
            </div>
            <div>Expired:</div>
            <div>{moment(record.expiredAt).format('DD MMM YYYY, HH:mm')}</div>
          </div>
        ),
        // filterDropdown: (
        //   <Filter
        //     field="createdAt"
        //     sort
        //     type="time"
        //     filterMethod={this.filter}
        //   />
        // ),
      },
      {
        title: 'Payment Source',
        dataIndex: 'paymentSource.accountName',
        key: 'paymentSource.accountName',
        render: (text, record) => (
          <div>
            <p className="order_amount">
              {text ? numberToMoney(parseInt(record.amount, 10) + parseInt(record.unique, 10)) : '-'}
            </p>
            <img
              className="order_bank-img"
              src={record.paymentSource.image}
              alt=""
            />
            <div>{record.paymentSource.accountNo}</div>
            <div>{record.paymentSource.accountName}</div>
          </div>
        ),
        filterDropdown: (
          // TODO: if originBank filter exists in URL, it should be checked in this filter dropdown
          <Filter
            field="originBank"
            filterMethod={this.filter}
            data={Object.values(originBanks)}
          />
        ),
        filterDropdownVisible: filterVisible.originBank,
        onFilterDropdownVisibleChange: visible =>
          this.onFilterVisibleChange(visible, 'originBank'),
      },
      {
        title: 'Refund',
        dataIndex: 'refundedAmount',
        key: 'refundedAmount',
        render: (text, record) => (
          <div>
            <p className="order_amount">{text ? numberToMoney(text) : '-'}</p>
            <img
              className="order_bank-img"
              src={record.refundedBank.image}
              alt=""
            />
            <p>Bank: {record.refundedBank.bank}</p>
            <div>{record.refundedBank && record.refundedBank.bankNo}</div>
            <div>{record.refundedBank && record.refundedBank.ownerName}</div>
          </div>
        ),
        // filterDropdown: (
        //   <Filter field="bankName" sort search filterMethod={this.filter} />
        // ),
      },
      {
        title: 'Transfer',
        dataIndex: 'amount',
        key: 'amount',
        render: (text, record) => (
          <div>
            <p className="order_amount">{numberToMoney(text)}</p>
            <img className="order_bank-img" src={record.image} alt="" />
            <div>{record.destinationBankNo}</div>
            <div>{record.ownerName}</div>
          </div>
        ),
        filterDropdown: (
          // TODO: if destBank filter exists in URL, it should be checked in this filter dropdown
          <Filter
            field="destBank"
            filterMethod={this.filter}
            data={Object.values(destBanks)}
          />
        ),
        filterDropdownVisible: filterVisible.destBank,
        onFilterDropdownVisibleChange: visible =>
          this.onFilterVisibleChange(visible, 'destBank'),
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        render: (text, record) => (
          <Select
            className={`order_status --${text.toLowerCase()}`}
            style={{ width: '100%', minWidth: 120 }}
            onChange={e => this.handleChangeStatus(e, record.orderId)}
            value={text}
          >
            {Object.keys(statuses).map(x => (
              <Select.Option
                key={x}
                className={`order_status-item --${x.split(' ').join('')}`}
                value={x}
              >
                {statuses[x]}
              </Select.Option>
            ))}
          </Select>
        ),
        filterDropdown: (
          // TODO: if status filter exists in URL, it should be checked in this filter dropdown
          <Filter
            field="status"
            filterMethod={this.filter}
            data={Object.values(statuses)}
          />
        ),
        filterDropdownVisible: filterVisible.status,
        onFilterDropdownVisibleChange: visible =>
          this.onFilterVisibleChange(visible, 'status'),
      },
    ]
    // console.log(data)
    return (
      <Main>
        <div className="order">
          <h1>Orders</h1>
          <Input.Search
            className="order_search"
            enterButton
            placeholder="#Order ID"
            onSearch={this.search}
          />
          <div className="table-responsive">
            <div style={{ marginBottom: 16 }}>
              <Row>
                <Col span={12}>
                  <span style={{ marginLeft: 8 }}>
                    {`Selected ${selectedRowKeys.length} items`}
                  </span>
                </Col>
                <Col span={12} style={{ textAlign: 'right' }}>
                  <Select
                    disabled={selectedRowKeys.length <= 0 || loadingSelected}
                    style={{ width: 250 }}
                    onChange={e => this.handleChangeStatusSelected(e)}
                    value=""
                    loading={loadingSelected}
                  >
                    <Select.Option
                      disabled
                      value=""
                    >
                      Change status selected order
                    </Select.Option>
                    {Object.keys(statuses).map(x => (
                      <Select.Option
                        key={x}
                        className={`order_status-item --${x.split(' ').join('')}`}
                        value={x}
                      >
                        {statuses[x]}
                      </Select.Option>
                    ))}
                  </Select>
                </Col>
              </Row>
            </div>
            <Table
              rowSelection={rowSelection}
              rowKey={record => record.orderId}
              columns={columns}
              dataSource={data}
              pagination={false}
              loading={loadingTable}
            />
            <div className="app-pagination">
              <Pagination
                current={currentPage}
                total={dataCount}
                onChange={this.changePage}
              />
            </div>
          </div>
          <ModalReadyToRefund
            visible={modal}
            modalOk={this.modalOk}
            closeModal={this.closeModal}
            changeRefundBank={this.changeRefundBank}
            changeRefundInput={this.changeRefundInput}
            refund={refund}
          />
          <OrderDetail
            visible={modalOrderDetail}
            close={this.closeModalOrderDetail}
            orderId={modalOrderId}
            user={modalUser}
          />
        </div>
      </Main>
    )
  }
}

Order.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
}

export default Order



// WEBPACK FOOTER //
// src/pages/order/index.js